import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';
import EachFile from './EachFile';

class Files extends Component {
	constructor(props) {
		super(props);
		this.state = {
			list: {},
			message: '',
			total: 0,
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			ready: false
		}
	}

	componentWillMount() {
		this.getFiles();
	}

	getFiles = () => {
		var self = this;
		Api.getFiles(JSON.stringify({ token: this.state.token }), function(response) {
			self.setState({
				list: response.list,
				total: response.total_results,
				message: response.message,
				ready: true
			});
		});
	}

	deleteFile = (fileID) => {
		var self = this;
        if(window.confirm("Are you sure you want to delete this file from the server? This action cannot be undone.")) {
            this.setState({
                ready: false
            }, function() {
                Api.deleteFile(JSON.stringify({ token: this.state.token, id: fileID }), function(response) {
                    if(response.status === 'Deleted') {
                    	self.getFiles();
                    }
                });
            });
        } else {
            return false;
        }
	}

	deleteFileAndContents = (fileID) => {
		var self = this;
        if(window.confirm("You are about to delete this file from the server and all of the contents from the database created from this file. Are you sure you want to continue? This action cannot be undone.")) {
            this.setState({
                ready: false
            }, function() {
                Api.deleteFileContents(JSON.stringify({ token: this.state.token, id: fileID }), function(response) {
                    if(response.status === 'Deleted') {
                    	self.getFiles();
                    }
                });
            });
        } else {
            return false;
        }
	}

	deleteInitialDatabase = () => {
		var self = this;
        if(window.confirm("You are about to delete the initial database the server and all of the contents from the database created from the beginning. Are you sure you want to continue? This action cannot be undone.")) {
            this.setState({
                ready: false
            }, function() {
                Api.deleteInitialDatabase(JSON.stringify({ token: this.state.token }), function(response) {
                    if(response.status === 'Deleted') {
                    	self.getFiles();
                    }
                });
            });
        } else {
            return false;
        }
	}

	eachEntry = (res, i) => {
		return(
			<div key={i}>
				<EachFile deleteFile={this.deleteFile} deleteFileAndContents={this.deleteFileAndContents} key={i} index={i}>
					{res}
				</EachFile>
			</div>
		);
	}

    render() {
    	return(
    		<div className="blockCtr patients br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to="/" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>Files List</h3>
    				<Link to="/files/import" className="addBtn br10TopRight">New Import</Link>
    			</div>
    			<div className="blockInfo">
					<div className="table">
						<div className="row titleRow mobileHide">
							<div style={{width: '20%', float: 'left'}}>Upload Date</div>
							<div style={{width: '25%', float: 'left'}}>File Name</div>
							<div style={{width: '15%', float: 'left'}}>File Type</div>
							<div style={{width: '15%', float: 'left'}}>Is Mapped</div>
							<div style={{width: '25%', float: 'left'}}>Actions</div>
						</div>
						<div className="file anim1 br5" style={{backgroundColor: '#EEEEEE'}}>
							<div className="row fileRow">
								<div className="rt" style={{width: '45%', float: 'left'}}><span className="mobileShowIB"><strong>File Name:</strong></span> INITIAL DATABASE</div>
								<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>File Type:</strong></span> N/A</div>
								<div className="rt" style={{width: '15%', float: 'left'}}><span className="mobileShowIB"><strong>Is Mapped:</strong></span> Yes</div>
								<div className="rt" style={{width: '25%', float: 'left'}}>
									<span className="mobileShowIB"><strong>Actions:</strong></span>
									<button className="fileLink" style={{ marginTop: -5 }} onClick={this.deleteInitialDatabase}><span className="fas fa-fw fa-trash"></span></button>
								</div>
							</div>
						</div>
						{this.state.ready ? this.state.list.map(this.eachEntry) : <img src={Preloader} alt="Fresenius Preloader" className="preloader" style={{display: 'block', maxHeight: 'auto'}} />}
					</div>
    			</div>
    		</div>
    	);
    }
}

export default Files;


// WEBPACK FOOTER //
// ./src/components/Files.js